<template>
  <div class="model-part">
    <div class="top-part flex-y-end">
      <span class="txt">{{ title }}</span>
      <img class="left-img" src="../../assets/img/box/left-top.png" />
      <img class="fill-part" :class="cWidth ? 'fill-width' : ''" src="../../assets/img/box/mid-top.png" />
      <img class="right-img" src="../../assets/img/box/right-top.png" />
    </div>
    <div class="bottom-part">
      <img class="left-img" src="../../assets/img/box/left-bottom.png" />
      <img class="fill-part" :class="cWidth ? 'fill-width' : ''" src="../../assets/img/box/mid-bottom.png" />
      <img class="right-img" src="../../assets/img/box/right-bottom.png" />
    </div>
    <img class="left-border" src="../../assets/img/box/left-border.png" />
    <img class="right-border" src="../../assets/img/box/right-border.png" />
    <div class="container">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: String
      },
      cWidth: {
        type: Boolean
      }
    }
  }
</script>
<style scoped lang="less">
  .model-part {
    position: relative;
    width: 100%;
    background: #030E21;
    .top-part {
      position: absolute;
      top: -30px;
      left: 0;
      z-index: 0;
      width: 100%;
      height: 32px;
      padding-left: 30px;
      background: #030E21;
      .txt {
        position: relative;
        z-index: 1;
        font-size: 16px;
        font-weight: 700;
        color: #FFFFFF;
        line-height: 26px;
      }
      .left-img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 320px;
        height: 100%;
      }
      .right-img {
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 0;
        width: 40px;
        height: 100%;
      }
      .fill-part {
        position: absolute;
        top: 0;
        right: 40px;
        z-index: 1;
        width: calc(100% - 360px);
        height: 100%;
      }
      .fill-width {
        width: 740px;
      }
    }
    .bottom-part {
      position: absolute;
      left: 0;
      bottom: -20px;
      z-index: 0;
      width: 100%;
      height: 20px;
      background: #030E21;
      .left-img {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 0;
        width: 320px;
        height: 100%;
      }
      .fill-part {
        position: absolute;
        right: 40px;
        bottom: 0;
        z-index: 1;
        width: calc(100% - 360px);
        height: 100%;
      }
      .fill-width {
        width: 740px;
      }
      .right-img {
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 0;
        width: 40px;
        height: 100%;
      }
    }
    .left-border {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
      width: 320px;
      height: 100%;
    }
    .right-border {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 0;
      width: 40px;
      height: 100%;
    }
    .container {
      position: relative;
      z-index: 3;
      width: 100%;
      padding: 10px 20px;
    }
  }
</style>